module.exports = __webpack_public_path__ + "img/10_12.d59303f1.png";